// ng2 polyfills
require('./polyfills');

// other libs
require('./libs');